<template>
  <div class="grey lighten-5 py-16" id="major-section">
    <center>
      <h1 v-if="!hasRegister">
        Pilih Konsentrasi<br />Yang Anda Minati Sekarang Juga!
      </h1>
      <h1 v-else>Status Pendaftaran</h1>
    </center>
    <div class="d-flex justify-center mt-13">
      <div grid-list-xs class="major-container">
        <v-row v-if="!hasRegister" justify="space-around">
          <v-col
            cols="12"
            v-for="majoring in majors"
            :key="majoring.name"
          >
          <h1 class="text-center mb-5">{{majoring.name}}</h1>
            <v-row justify="space-around">
              <v-col
                xs="12"
                sm="6"
                lg="4"
                cols="12"
                v-for="major in majoring.list"
                :key="major.name"
              >
                <v-card class="rounded-card major-col" elevation="0">
                  <v-img
                    class="major-image"
                    width="600"
                    :src="
                      require(`@/assets/img/major-thumbnail/${major.image}`)
                    "
                    alt="thumbnail"
                  ></v-img>
                  <div align="center" class="pa-5 mt-3">
                    <div class="major-content">
                      <div
                        class="font-weight-medium grey--text-darken-3"
                        style="font-size: 1.5rem"
                      >
                        {{ major.name }}
                      </div>
                      <div class="mt-5" v-html="major.description"></div>
                    </div>
                    <v-row justify="center">
                      <v-col cols="12">
                        <v-btn
                          :to="{
                            path: `${jurusan}/${major.url}`,
                          }"
                          text
                          class="no-transform margin-all"
                          >Lihat Selengkapnya<v-icon right
                            >mdi-chevron-right</v-icon
                          ></v-btn
                        >
                      </v-col>
                      <v-col cols="12">
                        <v-btn
                          :to="`daftar/${major.url}`"
                          class="btn-register white--text py-5 px-10"
                          >Daftar</v-btn
                        >
                      </v-col>
                    </v-row>
                  </div>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
        </v-row>

        <div
          v-if="hasRegister"
          class="has-register d-flex flex-column align-center text-center"
        >
          <p>{{ sw_status }} <a href="/kotak-masuk">kotak masuk.</a></p>
          <h1>{{ studentMajor }}</h1>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  name: "MajorSection",
  props: ["hasRegister", "studentMajor", "id_status"],
  data: () => ({
    sw_status: "",
    jurusan: "informasi/jurusan",
    majors: [
      {
        name: "Konsentrasi DKV",
        list: [
          {
            name: "DKV Konsentrasi Teknik Grafika",
            image: "produksi-grafika-major.png",
            url: "teknik-grafika",
            description:
              "Apa yang akan kamu pelajari? yang kamu pelajari di <strong>DKV Konsentrasi Teknik Grafika</strong> adalah offset printing, screen printing, digital printing, dan masih banyak lagi!",
          },
          {
            name: "DKV Konsentrasi Desain Grafika",
            image: "desain-grafika-major.png",
            url: "desain-grafika",
            description:
              "Apa yang kamu pelajari? yang kamu pelajari di <strong>DKV Konsentrasi Desain Grafika</strong> adalah basic graphic design, user interface (UI), user experience (UX), dan masih banyak lagi!",
          },
        ],
      },
      {
        name: "Konsentrasi Animasi",
        list: [
          {
            name: "Animasi 2D",
            image: "dkv-major.png",
            url: "animasi-2d",
            description:
              "Apa yang kamu pelajari? yang kamu pelajari di <strong>Animasi 2D</strong> adalah concept art & illustration, motion graphic, photography, dan masih banyak lagi!",
          },
          {
            name: "Animasi 3D",
            image: "animasi-major.png",
            url: "animasi-3d",
            description:
              "Apa yang kamu pelajari? yang kamu pelajari di <strong>Animasi 3D</strong> adalah basic shaping, modelling, texturing, rigging, dan masih banyak lagi!",
          },
        ],
      },
      {
        name: "Konsentrasi RPL",
        list: [
          {
            name: "Pengembangan Perangkat Lunak dan Gim",
            image: "rpl-major.png",
            url: "pengembangan-perangkat-lunak-gim",
            description:
              "Apa yang kamu pelajari? yang kamu pelajari di <strong>Pengembangan Perangkat Lunak dan Gim</strong> adalah programming, computer knowledge, software development, dan masih banyak lagi!",
          },
        ],
      },
    ],
  }),
  methods: {
    setStatusInfo() {
      const status = this.id_status;
      if (status == 0)
        this.sw_status = "Formulir pendaftaran sedang diproses. Silakan cek ";
      else if (status == 1)
        this.sw_status = "Formulir pendaftaran ditolak. Silakan cek ";
      else if (status == 2)
        this.sw_status = "Mengirim ulang formulir pendaftaran. Silakan cek ";
      else if (status == 3)
        this.sw_status = "Formulir pendaftaran diterima. Silakan cek ";
      else if (status == 4)
        this.sw_status =
          "Lampiran biaya pendaftaran sedang diproses. Silakan cek ";
      else if (status == 5)
        this.sw_status = "Lampiran biaya pendaftaran ditolak. Silakan cek ";
      else if (status == 6)
        this.sw_status =
          "Mengirim ulang lampiran biaya pendaftaran. Silakan cek ";
      else if (status == 7)
        this.sw_status = "Lampiran biaya pendaftaran diterima. Silakan cek ";
      else if (status > 7)
        this.sw_status = "Pendaftaran sedang diproses. Silakan cek ";
    },
  },
  mounted() {
    this.setStatusInfo();
  },
};
</script>


<style scoped>
.btn-register {
  background-color: #24305e !important;
  border-radius: 10px !important;
  font-size: 1rem;
  letter-spacing: 0.2rem;
}
.no-transform {
  text-transform: unset !important;
  color: #fd8061;
}

.rounded-card {
  border-radius: 15px !important;
}

.major-container {
  width: 80%;
}

a {
  text-decoration: none;
}

.major-col {
  height: 650px;
}

.major-image {
  height: 250px;
}

.major-content {
  height: 180px !important;
}

.major-col h1 {
  letter-spacing: 5px;
  text-align: center;
  line-height: 3rem;
}

.major-action {
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 2;
}

.major-action .major-text {
  width: 50%;
  margin: 0 auto;
}

.major-action .major-text h2 {
  letter-spacing: 2px;
  text-align: center;
  line-height: 1.8rem;
  text-shadow: 0 3px 6px rgba(0, 0, 0, 0.2);
}

.margin-all {
  margin-top: 2.8rem;
}

@media screen and (max-width: 990px) {
  .major-col {
    height: 650px;
  }

  .margin-all {
    margin-top: 2rem;
  }
}

@media screen and (max-width: 910px) {
  .major-col {
    height: 680px;
  }

  .margin-all {
    margin-top: 4rem;
  }
}

@media screen and (max-width: 890px) {
  .major-col {
    height: 800px;
  }

  .margin-all {
    margin-top: 13rem;
  }
}

@media screen and (max-width: 600px) {
  .major-col {
    height: 630px;
  }

  .margin-all {
    margin-top: 1.8rem;
  }
}

@media screen and (max-width: 500px) {
  .major-col {
    height: 700px;
  }

  .margin-all {
    margin-top: 6rem;
  }
}

@media screen and (max-width: 450px) {
  .major-col {
    height: 750px;
  }

  .margin-all {
    margin-top: 9rem;
  }
}
</style>